import React from "react";
import { Link } from "react-router-dom";

// Shared product card used by the /products hub and the home-page products section.
function ProductCard({ app }) {
  if (app.comingSoon) {
    return (
      <div className="app-card coming-soon">
        <div className="app-card-icon">🔮</div>
        <p className="app-card-name">{app.name}</p>
        <p className="app-card-tagline">{app.tagline}</p>
      </div>
    );
  }

  const inner = (
    <>
      {app.screenshots && app.screenshots[0] ? (
        <div className={`app-card-screenshot${app.screenshotContain ? " contain" : ""}`}>
          <img src={app.screenshots[0]} alt={app.name} />
        </div>
      ) : app.icon ? (
        <div className="app-card-icon">
          <img src={app.icon} alt={app.name} style={{ width: 48, height: 48, borderRadius: 12 }} />
        </div>
      ) : null}
      {app.badge && <span className="app-card-soon">{app.badge}</span>}
      <p className="app-card-name">{app.name}</p>
      <p className="app-card-tagline">{app.tagline}</p>
      <div className="app-card-badges">
        {app.playStoreUrl && (
          <a href={app.playStoreUrl} className="store-badge" target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>Google Play</a>
        )}
        {app.appStoreUrl && (
          <a href={app.appStoreUrl} className="store-badge" target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>App Store</a>
        )}
      </div>
      <span className="app-card-arrow">→</span>
    </>
  );

  return app.externalUrl ? (
    <a href={app.externalUrl} target="_blank" rel="noreferrer" className="app-card">
      {inner}
    </a>
  ) : (
    <Link to={`/products/${app.slug}`} className="app-card">
      {inner}
    </Link>
  );
}

export default ProductCard;
